<template>
  <v-card class="rounded-0" flat>

    <v-card-title class="d-flex justify-center align-center pa-3">
      <a href="/" class="mr-auto ml-auto"><img src="../../assets/LOGO-dark-mode.svg" alt="Logo GOAT Soluções Digitais" width="140"/></a>
      <ThemeButton />
    </v-card-title>

    <div class=" d-flex flex-row justify-center align-center">
      <v-tabs >
        <v-tab class="rounded-s" style="font-size: 14px" to="/">Início</v-tab>
        <v-tab style="font-size: 14px" to="/sobre">Quem Somos</v-tab>
        <v-tab style="font-size: 14px" to="/produtos">Produtos</v-tab>
        <v-tab style="font-size: 14px" to="/parceiros">Parceiros</v-tab>
        <v-tab style="font-size: 14px" to="/contato">Fale Conosco</v-tab>
        <v-tab class="rounded-e" to="/status">Status</v-tab>
        <v-tab class="rounded-e" to="/graficos">Métricas RSC PCCTAE</v-tab>
      </v-tabs>
    </div>
  </v-card>
</template>

<script>
import { defineComponent } from "vue";
import ThemeButton from "@/components/themeButton/ThemeButton.vue";
export default defineComponent({
  components: {ThemeButton}
});
</script>
